import Link from '@eversports/klimt-primitives/legacy/Link'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'

import { ManagerLinksMapping } from '../../../../App.constants'
import { Localized } from '../../../../localization/react'

const CorporateDisclaimer = () => {
  const { tld } = useSettingsContext()

  return (
    <Text variant="badge" sx={{ color: 'darkgray', fontWeight: 'initial' }}>
      <Localized
        id="corporate-partner-promo-text"
        params={{
          link: (
            <Link
              to={ManagerLinksMapping[tld].corporate}
              external
              blank
              ariaLabel="Learn about Eversports' special corporate deals"
            >
              <Text
                component="span"
                variant="badge"
                sx={{ color: 'primary.main', textDecoration: 'underline', fontWeight: 'initial' }}
              >
                <Localized id="corporate-partner-promo-text-link" />
              </Text>
            </Link>
          ),
        }}
      />
    </Text>
  )
}

export default CorporateDisclaimer
